// quiz-data.js
// Globale Namespace-Vorbereitung
window.CatQuiz = window.CatQuiz || {};

CatQuiz.data = {
  // =========================
  // Zusammensetzung (Modal-Tab: "Zusammensetzung")
  // =========================
  INGREDIENTS_DATA: {
    // WICHTIG: Key muss exakt "huhnForelle" heißen (camelCase),
    // weil dein JS mit productKey === "huhnForelle" arbeitet.
    huhnForelle: [
      { ingredient: "75 % Huhn (davon 50 % Hühnerfilet, 17,5 % Hühnermägen und Hühnerherzen, 7,5 % Hühnerleber)", amount: "", why: "" },
      { ingredient: "19 % Fleischbrühe", amount: "", why: "" },
      { ingredient: "2 % Kürbis", amount: "", why: "" },
      { ingredient: "1 % hydrolysiertes Geflügelprotein", amount: "", why: "" },
      { ingredient: "1 % hydrolysiertes Kollagen", amount: "", why: "" },
      { ingredient: "0,5 % Lachsöl", amount: "", why: "" },
      { ingredient: "0,5 % Bierhefe", amount: "", why: "" },
      { ingredient: "0,2 % Chicoréewurzel", amount: "", why: "" },
      { ingredient: "0,2 % Blaubeeren", amount: "", why: "" },
      { ingredient: "0,2 % Eierschalenpulver", amount: "", why: "" },
      { ingredient: "0,2 % Flohsamenschalen", amount: "", why: "" },
      { ingredient: "0,1 % Seealgenmehl", amount: "", why: "" },
      { ingredient: "0,1 % Katzenminze", amount: "", why: "" }
    ],

    huhn: [
      { ingredient: "75 % Huhn (davon 50 % Hühnerfilet, 17,5 % Hühnermägen und Hühnerherzen, 7,5 % Hühnerleber)", amount: "", why: "" },
      { ingredient: "19 % Fleischbrühe", amount: "", why: "" },
      { ingredient: "2 % Kürbis", amount: "", why: "" },
      { ingredient: "1 % hydrolysiertes Geflügelprotein", amount: "", why: "" },
      { ingredient: "1 % hydrolysiertes Kollagen", amount: "", why: "" },
      { ingredient: "0,5 % Lachsöl", amount: "", why: "" },
      { ingredient: "0,5 % Bierhefe", amount: "", why: "" },
      { ingredient: "0,2 % Chicoréewurzel", amount: "", why: "" },
      { ingredient: "0,2 % Blaubeeren", amount: "", why: "" },
      { ingredient: "0,2 % Eierschalenpulver", amount: "", why: "" },
      { ingredient: "0,2 % Flohsamenschalen", amount: "", why: "" },
      { ingredient: "0,1 % Seealgenmehl", amount: "", why: "" },
      { ingredient: "0,1 % Katzenminze", amount: "", why: "" }
    ]
  },

  // =========================
  // Analytische Werte (Modal-Tab: "Analytische Werte")
  // =========================
  ANALYTICS_DATA: {
    huhnForelle: [
      { name: "Rohprotein",   amount: "12 %",   why: "" },
      { name: "Rohfett",      amount: "7 %",    why: "" },
      { name: "Rohfaser",     amount: "0,3 %",  why: "" },
      { name: "Rohasche",     amount: "1,9 %",  why: "" },
      { name: "Feuchtigkeit", amount: "74 %",   why: "" },
      { name: "Calcium",      amount: "0,3 %",  why: "" },
      { name: "Phosphor",     amount: "0,2 %",  why: "" }
    ],

    huhn: [
      { name: "Rohprotein",   amount: "12 %",   why: "" },
      { name: "Rohfett",      amount: "7 %",    why: "" },
      { name: "Rohfaser",     amount: "0,3 %",  why: "" },
      { name: "Rohasche",     amount: "1,9 %",  why: "" },
      { name: "Feuchtigkeit", amount: "74 %",   why: "" },
      { name: "Calcium",      amount: "0,3 %",  why: "" },
      { name: "Phosphor",     amount: "0,2 %",  why: "" }
    ]
  },

  // =========================
  // Zusatzstoffe (Modal-Tab: "Zusatzstoffe")
  // (bei dir aktuell über MICRONUTRIENTS_DATA gerendert)
  // =========================
  MICRONUTRIENTS_DATA: {
    huhn: [
      { nutrient: "Vitamin D3", amount: "150 I.E./kg", why: "" },
      { nutrient: "Vitamin E", amount: "30 mg/kg", why: "" },
      { nutrient: "Kupfer (als Kupfer(II)-sulfat, Pentahydrat)", amount: "2 mg/kg", why: "" },
      { nutrient: "Selen (als Natriumselenit)", amount: "0,1 mg/kg", why: "" },
      { nutrient: "Zink (als Aminosäuren-Zinkchelat, Hydrat)", amount: "39 mg/kg", why: "" },
      { nutrient: "Jod (als Calciumjodat, wasserfrei)", amount: "1 mg/kg", why: "" },
      { nutrient: "Mangan (als Mangansulfat)", amount: "1,4 mg/kg", why: "" }
    ],

    huhnForelle: [
      { nutrient: "Vitamin D3", amount: "150 I.E./kg", why: "" },
      { nutrient: "Vitamin E", amount: "30 mg/kg", why: "" },
      { nutrient: "Kupfer (als Kupfer(II)-sulfat, Pentahydrat)", amount: "2 mg/kg", why: "" },
      { nutrient: "Selen (als Natriumselenit)", amount: "0,1 mg/kg", why: "" },
      { nutrient: "Zink (als Aminosäuren-Zinkchelat, Hydrat)", amount: "39 mg/kg", why: "" },
      { nutrient: "Jod (als Calciumjodat, wasserfrei)", amount: "1 mg/kg", why: "" },
      { nutrient: "Mangan (als Mangansulfat)", amount: "1,4 mg/kg", why: "" }
    ]
  },

// =========================
// Fütterungsempfehlungen (Modal-Tab: "Fütterungsempfehlungen")
// =========================
FEEDING_RECOMMENDATIONS_DATA: {
  // Falls die Tabelle für beide Sorten identisch ist, kannst du sie 1:1 kopieren.
  huhnForelle: {
    leftHeader: "Gewicht:",
    rightHeader: "Gramm pro Tag",
    rows: [
      { weight: "2 - 3 kg", grams: "108 - 141 g" },
      { weight: "4 - 5 kg", grams: "171 - 199 g" },
      { weight: "6 - 7 kg", grams: "225 - 249 g" },
      { weight: "8 kg",     grams: "273 - 316 g" }
    ]
  },

  huhn: {
    leftHeader: "Gewicht:",
    rightHeader: "Gramm pro Tag",
    rows: [
      { weight: "2 - 3 kg", grams: "105 - 138 g" },
      { weight: "4 - 5 kg", grams: "167 - 194 g" },
      { weight: "6 - 7 kg", grams: "219 - 243 g" },
      { weight: "8 kg",     grams: "266 - 309 g" }
    ]
  }
},


  // =========================
  // UI-only Meta fürs Modal (Titel/kleine Labels)
  // =========================  
  MODAL_META: {
    huhn: {
      title: "Katzenliebe Huhn:",
      headerRight: ""
    },
    huhnForelle: {
      title: "Katzenliebe Huhn-Forelle:",
      headerRight: "Fütterungsempfehlung"
    }
  },

  // =========================
  // Pricing (wird zur Laufzeit aus Shopify-Variant JSON befüllt) (wird aus irgendeinem grund noch gebraucht, obwohl es überflüssig ist)
  // =========================
  PRICING: {
    currency: "EUR",
    unitSizeGrams: 100,

    // Legacy-Fallbacks; quiz-pricing.js hydriert die echten Preise aus Shopify.
    variants: {
      huhn100g: 120,
      huhnForelle100g: 120
    },
    variantsByCode: {
      huhn: 120,
      huhn_forelle: 120
    },
    variantsById: {},
    discounts: {
      trialBox: 0.80
    }
  }

};
